"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.detailData = exports.overviewData = void 0;
var overviewData = [{
  "id": "Total",
  "color": "rgb(20, 148, 244)",
  "data": [{
    "x": "2019-05-01",
    "y": 97
  }, {
    "x": "2019-05-02",
    "y": 10
  }, {
    "x": "2019-05-03",
    "y": 11
  }, {
    "x": "2019-05-04",
    "y": 1
  }, {
    "x": "2019-05-05",
    "y": 33
  }, {
    "x": "2019-05-06",
    "y": 1
  }, {
    "x": "2019-05-07",
    "y": 20
  }, {
    "x": "2019-05-08",
    "y": 150
  }, {
    "x": "2019-05-09",
    "y": 66
  }, {
    "x": "2019-05-10",
    "y": 0
  }, {
    "x": "2019-05-11",
    "y": 36
  }, {
    "x": "2019-05-12",
    "y": 60
  }, {
    "x": "2019-05-13",
    "y": 26
  }, {
    "x": "2019-05-14",
    "y": 30
  }, {
    "x": "2019-05-15",
    "y": 67
  }, {
    "x": "2019-05-16",
    "y": 18
  }, {
    "x": "2019-05-17",
    "y": 36
  }, {
    "x": "2019-05-18",
    "y": 23
  }, {
    "x": "2019-05-19",
    "y": 105
  }, {
    "x": "2019-05-20",
    "y": 39
  }, {
    "x": "2019-05-21",
    "y": 146
  }, {
    "x": "2019-05-22",
    "y": 68
  }, {
    "x": "2019-05-23",
    "y": 92
  }, {
    "x": "2019-05-24",
    "y": 123
  }, {
    "x": "2019-05-25",
    "y": 151
  }, {
    "x": "2019-05-26",
    "y": 118
  }, {
    "x": "2019-05-27",
    "y": 85
  }, {
    "x": "2019-05-28",
    "y": 56
  }, {
    "x": "2019-05-29",
    "y": 119
  }, {
    "x": "2019-05-30",
    "y": 186
  }, {
    "x": "2019-05-31",
    "y": 63
  }]
}];
exports.overviewData = overviewData;
var detailData = [{
  "id": "japan",
  "color": "hsl(11, 70%, 50%)",
  "data": [{
    "x": "plane",
    "y": 208
  }, {
    "x": "helicopter",
    "y": 34
  }, {
    "x": "boat",
    "y": 116
  }, {
    "x": "train",
    "y": 207
  }, {
    "x": "subway",
    "y": 192
  }, {
    "x": "bus",
    "y": 276
  }, {
    "x": "car",
    "y": 198
  }, {
    "x": "moto",
    "y": 99
  }, {
    "x": "bicycle",
    "y": 54
  }, {
    "x": "horse",
    "y": 24
  }, {
    "x": "skateboard",
    "y": 201
  }, {
    "x": "others",
    "y": 120
  }]
}, {
  "id": "france",
  "color": "hsl(141, 70%, 50%)",
  "data": [{
    "x": "plane",
    "y": 167
  }, {
    "x": "helicopter",
    "y": 234
  }, {
    "x": "boat",
    "y": 75
  }, {
    "x": "train",
    "y": 93
  }, {
    "x": "subway",
    "y": 238
  }, {
    "x": "bus",
    "y": 242
  }, {
    "x": "car",
    "y": 61
  }, {
    "x": "moto",
    "y": 200
  }, {
    "x": "bicycle",
    "y": 267
  }, {
    "x": "horse",
    "y": 69
  }, {
    "x": "skateboard",
    "y": 76
  }, {
    "x": "others",
    "y": 168
  }]
}, {
  "id": "us",
  "color": "hsl(216, 70%, 50%)",
  "data": [{
    "x": "plane",
    "y": 241
  }, {
    "x": "helicopter",
    "y": 36
  }, {
    "x": "boat",
    "y": 127
  }, {
    "x": "train",
    "y": 186
  }, {
    "x": "subway",
    "y": 102
  }, {
    "x": "bus",
    "y": 149
  }, {
    "x": "car",
    "y": 247
  }, {
    "x": "moto",
    "y": 197
  }, {
    "x": "bicycle",
    "y": 138
  }, {
    "x": "horse",
    "y": 220
  }, {
    "x": "skateboard",
    "y": 84
  }, {
    "x": "others",
    "y": 80
  }]
}, {
  "id": "germany",
  "color": "hsl(196, 70%, 50%)",
  "data": [{
    "x": "plane",
    "y": 185
  }, {
    "x": "helicopter",
    "y": 159
  }, {
    "x": "boat",
    "y": 266
  }, {
    "x": "train",
    "y": 96
  }, {
    "x": "subway",
    "y": 166
  }, {
    "x": "bus",
    "y": 53
  }, {
    "x": "car",
    "y": 40
  }, {
    "x": "moto",
    "y": 260
  }, {
    "x": "bicycle",
    "y": 8
  }, {
    "x": "horse",
    "y": 148
  }, {
    "x": "skateboard",
    "y": 156
  }, {
    "x": "others",
    "y": 179
  }]
}, {
  "id": "norway",
  "color": "hsl(26, 70%, 50%)",
  "data": [{
    "x": "plane",
    "y": 192
  }, {
    "x": "helicopter",
    "y": 289
  }, {
    "x": "boat",
    "y": 149
  }, {
    "x": "train",
    "y": 125
  }, {
    "x": "subway",
    "y": 194
  }, {
    "x": "bus",
    "y": 36
  }, {
    "x": "car",
    "y": 155
  }, {
    "x": "moto",
    "y": 162
  }, {
    "x": "bicycle",
    "y": 238
  }, {
    "x": "horse",
    "y": 267
  }, {
    "x": "skateboard",
    "y": 262
  }, {
    "x": "others",
    "y": 254
  }]
}];
exports.detailData = detailData;